import { render } from "./IconEmail.vue?vue&type=template&id=37da17ac"
import script from "./IconEmail.vue?vue&type=script&lang=js"
export * from "./IconEmail.vue?vue&type=script&lang=js"
script.render = render

export default script